import { ErrorLogComponent } from '@cian/error-log-component';

import { clsx } from 'clsx';
import { Children, type FC, type JSX } from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';

import styles from './ContentWrapper.css';

interface IContentWrapperProps {
  children: (JSX.Element | null)[];
  topOffset: 'content' | 'header';
}

interface IUnguardedBlockProps {
  children: JSX.Element;
}

/**
 * Блок с основным контентом для индексации: ContentWrapper не оборачивает его в локальный boundary.
 * Ошибка уходит в корневой boundary, который показывает снимок SSR, и контент не пропадает
 */
export const UnguardedBlock: FC<IUnguardedBlockProps> = ({ children }) => children;

export const ContentWrapper: FC<IContentWrapperProps> = ({ children, topOffset }) => {
  const { logger } = useApplicationContext();

  return (
    <div className={clsx(styles['wrapper'], topOffset === 'content' && styles['wrapper--content-offset'])}>
      {Children.map(children, child => {
        if (!child || child.type === UnguardedBlock) {
          return child;
        }

        return <ErrorLogComponent logger={logger}>{child}</ErrorLogComponent>;
      })}
    </div>
  );
};
